import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { Spin, Tooltip, Select, Modal, Input } from "antd";
// import Swal from "sweetalert2";
import EditDryerEquip from "./EditEquipment";
import AddDryerEquip from "./AddEquipment";
import {
  getApiBaseUrl,
  // GET_EQUIP,
  GET_LOCATIONS,
  // UPDATE_WASH_EQUIP_STATUS,
  LOGIN,
  ADD_ACTIVITY,
} from "../../Config/Config";

const DryerEquip = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { Option } = Select;
  const [selectedLocation, setSelectedLocation] = useState(0);

  const [locations, setLocations] = useState([]);

  const [equipments, setEquipments] = useState([]);

  const [selectedEquipment, setSelectedEquipment] = useState(null);

  const [reauthVisible, setReauthVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  //  const [selectedRecord, setSelectedRecord] = useState();

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const fetchLocations = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      const locationList = result?.ResultData || [];
      setLocations(locationList);

      if (locationList.length > 0) {
        setSelectedLocation(locationList[0].BlockId);
      }
    } catch (error) {
      console.error("Failed to fetch locations:", error);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    if (selectedLocation) {
      fetchEquipments(selectedLocation);
    }
  }, [selectedLocation]);

  const fetchEquipments = async (blockId) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/Blocks/getPressureGroups?BlockId=${blockId}`
      );
      const result = await response.json();

      const equipmentList = result?.ResultData || [];
      setEquipments(equipmentList);

      // ✅ Auto select first equipment Id
      if (equipmentList.length > 0) {
        setSelectedEquipment(equipmentList[0].Id);
      } else {
        setSelectedEquipment(null);
      }

      setData([]); // clear old results if any
    } catch (error) {
      console.error("Failed to fetch equipments:", error);
    }
  };

  useEffect(() => {
    if (selectedLocation && selectedEquipment) {
      fetchResults(selectedLocation, selectedEquipment);
    }
  }, [selectedLocation, selectedEquipment]);

  const fetchResults = async (blockId, pressureGroupId) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/Blocks/getPressuredataByGroup?BlockId=${blockId}&PressureGroupId=${pressureGroupId}`
      );
      const result = await response.json();
      setData(result?.ResultData || []);
    } catch (error) {
      console.error("Failed to fetch result data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Instrument Description",
      dataIndex: "Name",
      key: "Name",
      sorter: (a, b) => a?.Name?.localeCompare(b?.Name),
    },
    {
      title: "Instrument ID",
      dataIndex: "EquipmentId",
      key: "EquipmentId",
      sorter: (a, b) =>
        a?.EquipmentId?.localeCompare(b?.EquipmentId || "") ?? 0,
      render: (value) => value,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Instrument <br />
          Min Range
        </div>
      ),
      dataIndex: "Min",
      key: "Min",
      sorter: (a, b) => a.Min - b.Min,
      render: (value) => (value ? value : "0"),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Instrument <br />
          Max Range
        </div>
      ),
      dataIndex: "max",
      key: "max",
      sorter: (a, b) => a.max - b.max,
      render: (value) => (value ? value : "0"),
    },
    {
      title: "UOM",
      dataIndex: "Unit",
      key: "Unit",
      sorter: (a, b) => a?.Unit?.localeCompare(b.Unit),
      render: (value) => (value ? value : "-"),
    },
    {
      title: "Least Count",
      dataIndex: "LeastCount",
      key: "LeastCount",
      sorter: (a, b) => a?.LeastCount - b?.LeastCount,
      render: (value) => (value ? value : "0"),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Instrument <br />
          Operating Min
        </div>
      ),
      dataIndex: "OperatingMin",
      key: "OperatingMin",
      sorter: (a, b) => a?.OperatingMin?.localeCompare(b.OperatingMin),
      render: (value) => (value ? value : "0"),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Instrument <br />
          Operating Max
        </div>
      ),
      dataIndex: "OperatingMax",
      key: "OperatingMax",
      sorter: (a, b) => a?.OperatingMax?.localeCompare(b.OperatingMax),
      render: (value) => (value ? value : "0"),
    },

    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            {/* {record?.Type == 0 && ( */}
            <Link
              to="#"
              className=" me-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#EditDryerEquipOffcanvas"
              onClick={() => setSelectedEquip(record)}
              title="Edit"
            >
              <i data-feather="edit" className="feather-edit text-info"></i>
            </Link>
            {/* )} */}
            <Tooltip title="Delete Equipment">
              <Link
                to="#"
                className="me-2 p-2 d-none"
                onClick={() => setSelectedEquip(record)}
                title="Update Status"
              >
                <i
                  data-feather="trash-2"
                  className="feather-trash-2 text-danger"
                ></i>
              </Link>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];

  const [selectedEquip, setSelectedEquip] = useState();

  const handleLocationChange = (value) => {
    setSelectedLocation(value);
    // fetchEquipments(value);
  };

  const handleEquipmentChange = (value) => {
    setSelectedEquipment(value);
    fetchResults(selectedLocation, value); // value === Id
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setIsLoading(true);
    setPasswordError("");
    const username = user?.UserName || user?.Username;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();

      if (loginData?.Message === "Login successful") {
        setReauthVisible(false);
        setPassword("");
        // await handleDeleteBlockConfirmed(selectedRecord);
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password."
        );
        await logActivity(
          0,
          `Failed reauthentication for deleting Block "}" by ${username}`
        );
      }
    } catch (error) {
      console.error("Reauthentication error:", error);
      setPasswordError("Something went wrong. Please try again.");
      await logActivity(
        0,
        `Reauthentication error for deleting Block "" by ${username}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const logActivity = async (isSuccess, note) => {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user.UserID || 0,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: note,
          Location: "deleteBlock",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Error logging activity:", err);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Equipment{" "}
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Equipment</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                // onClick={() => handleAdd(masterType)}
                data-bs-toggle="offcanvas"
                data-bs-target="#AddDryerEquipOffcanvas"
                aria-controls="AddDryerEquipOffcanvas"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>

          <div>
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
                <div className="search-set mt-4"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3 gap-3">
                  <Select
                    showSearch
                    placeholder="Select Block"
                    optionFilterProp="children"
                    value={selectedLocation || undefined}
                    onChange={handleLocationChange}
                    style={{ width: 200 }}
                    dropdownStyle={{ width: 200 }}
                    filterOption={(input, option) =>
                      (option?.children ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option key={0} value={0} disabled>
                      Select Location
                    </Option>
                    {locations.map((loc) => (
                      <Option key={loc.BlockId} value={loc.BlockId}>
                        {loc.BlockName}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    placeholder="Select Equipment"
                    value={selectedEquipment || undefined}
                    onChange={handleEquipmentChange}
                    style={{ width: 220 }}
                    optionFilterProp="children"
                    disabled={!selectedLocation}
                  >
                    {equipments.map((eq) => (
                      <Option
                        key={eq.Id} // ✅ correct
                        value={eq.Id} // ✅ correct
                      >
                        {eq.GroupName}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : data.length > 0 ? (
                    <Table dataSource={data} columns={columns} />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          <EditDryerEquip editObj={selectedEquip} />
          <AddDryerEquip />
          <Modal
            title="Confirm Password"
            open={reauthVisible}
            onOk={handlePasswordSubmit}
            onCancel={() => {
              setReauthVisible(false);
              setPassword("");
              setPasswordError("");
            }}
            confirmLoading={isLoading}
            width={350}
          >
            <Spin spinning={isLoading}>
              <Input.Password
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
              />
              {passwordError && (
                <div className="text-danger mt-2">{passwordError}</div>
              )}
            </Spin>
          </Modal>
        </>
      </div>
    </>
  );
};

export default DryerEquip;
